import React  from 'react'

import {FieldGoalListViewProps} from "../../../render/goal-list/goal-list-view"

const debug = false
// const debug = "FieldNumber_GoalListView"

export default function FieldNumber_GoalListView(props:FieldGoalListViewProps) {

    debug && console.log(debug, 'render', props)

    const value = _.get(props.model, props.field.fieldId, null)

    const classes = Classes("ui5-txt-less-important-small txt-truncate p-l-10 m-l-1", props.className, {
        'invalid-value': !props.field.isValueValid(value)
    })

    const displayValue = props.field.getDisplayValue(value)

    // div title attribute is required for pseudo element :before to make bold and not bold text the same width
    return (
        <div className={classes} title={displayValue}>
            {!_.isNil(value) && _.get(props.field.components, 'ValuePrefix', false)}
            {displayValue}
        </div>
    );
}
